import type {Filter} from "_types/filters";
import {observable, ObservableObject} from "@legendapp/state";

export function makeFilters(filters: Filter[]) {
    const obj = {
        toRequest: () => {
            const result = {};
            filters.forEach(({name}) => {
                const {value} = obj[name];
                if (value !== undefined) {
                    result[name] = value;
                }
            });
            return result;
        },
        getFilterValue: (k: string) => obj[k].value,
        resetFilters: () => {
            filters.forEach(({name, init}) => {
                obj[name].value = init;
                obj[name].badge = '';
            });
        }
    };

    filters.forEach(({name, init}) => obj[name] = {
        value: init,
        badge: '',
    });

    const $onFilterChange = observable<any>(obj) as ObservableObject<any>;

    return {filters, $onFilterChange};
}
